export enum PURCHASE_TYPES {
    COURSE = 1,
    MODULE = 2,
    CERTIFICATE = 3
}
